import { Button, Stack } from "@mui/material";
import { SelectedGender } from "../../../models/SelectedGender";
import { useTranslation } from "react-i18next";
export type Props = {
  selectedGender: SelectedGender | SelectedGender[],
  setSelectectionHandler: (selection:SelectedGender) => void;
}

const GenderFilterComponent:React.FC<Props>=({selectedGender,setSelectectionHandler})=>{
  const {t} = useTranslation();

  const isButtonPressed = (
    selection: SelectedGender | SelectedGender[],
    indication:SelectedGender
  ): boolean => {
    if (Array.isArray(selection)) {
      return selection.indexOf(indication) > -1;
    }
    else {
       return selection === indication;
    }
  }

  return(
    <div className="filter-type-container">
      <label>{t("filter_label_gender")}</label>
      <Stack className='stack' spacing={1} direction="row" style={{ marginBottom: '7px' }}>
        <Button 
          style={{ width: "126px" }} 
          variant={ isButtonPressed(selectedGender, SelectedGender.women) ? "contained" : "outlined" } 
          aria-pressed={ isButtonPressed(selectedGender, SelectedGender.women) } 
          size='small'
          onClick={()=>{ 
            setSelectectionHandler(SelectedGender.women)
          }}
        >
          {t("filter_button_gender_women")}
        </Button>

        <Button 
          style={{ width: "126px" }} 
          variant={ isButtonPressed(selectedGender, SelectedGender.male) ? "contained" : "outlined" } 
          aria-pressed={ isButtonPressed(selectedGender, SelectedGender.male) } 
          size='small'
          onClick={()=>{
            setSelectectionHandler(SelectedGender.male)
          }}
        >
          {t("filter_button_gender_men")}
        </Button>
      </Stack>

      <label>{t("filter_label_or")}</label>

      <Stack className='stack' spacing={1} direction="row">
        <Button 
          style={{ width: "259px" }}
          variant={ isButtonPressed(selectedGender,SelectedGender.male_women_diff) ? "contained" : "outlined" }
          aria-pressed={ isButtonPressed(selectedGender,SelectedGender.male_women_diff) }
          size='small'
          onClick={()=>{
            setSelectectionHandler(SelectedGender.male_women_diff)
          }}
        >
          {t("filter_button_gender_women_men")}
        </Button>
      </Stack>
    </div>)
}

export default GenderFilterComponent;